export { default as Img200 } from './processed/200/Tomb-Raider.jpg';
export { default as Img400 } from './processed/400/Tomb-Raider.jpg';
export { default as Imgthumb } from './processed/thumb/Tomb-Raider.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Tomb-Raider.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Tomb-Raider.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      203,
      4,
      4
    ],
    "_population": 2847,
    "_hsl": [
      0,
      0.9613526570048307,
      0.40588235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      146,
      9,
      8
    ],
    "_population": 245,
    "_hsl": [
      0.0012077294685990338,
      0.8961038961038961,
      0.30196078431372547
    ]
  },
  "Muted": {
    "_rgb": [
      92,
      165,
      144
    ],
    "_population": 397,
    "_hsl": [
      0.4520547945205479,
      0.2885375494071147,
      0.503921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      194,
      183,
      159
    ],
    "_population": 65,
    "_hsl": [
      0.11428571428571432,
      0.2229299363057324,
      0.692156862745098
    ]
  },
  "DarkMuted": {
    "_rgb": [
      91,
      66,
      46
    ],
    "_population": 2211,
    "_hsl": [
      0.0740740740740741,
      0.3284671532846716,
      0.26862745098039215
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Tomb-Raider.js